import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	sectionTitle: {
		id: 'home.for-you.rovo-agents-for-you.section-title',
		defaultMessage: 'Rovo Agents for you',
		description:
			'Header for the "Rovo Agents for you" section on Confluence Home / For You, which surfaces recommended AI agent cards',
	},
	labsLozenge: {
		id: 'home.for-you.rovo-agents-for-you.labs-lozenge',
		defaultMessage: 'Labs',
		description:
			'Label on a lozenge indicating the "Rovo Agents for you" feature is part of the early-access Labs program',
	},
	tryItCta: {
		id: 'home.for-you.rovo-agents-for-you.try-it-cta',
		defaultMessage: 'Try it',
		description:
			'Call to action revealed on a Rovo agent card on hover/focus that opens the agent in the Rovo sidebar',
	},
	tryItCtaLabel: {
		id: 'home.for-you.rovo-agents-for-you.try-it-cta-label',
		defaultMessage: 'Try {agentTitle}',
		description:
			'Accessible label for the "Try it" button on a Rovo agent card; {agentTitle} is the name of the agent that opens in the Rovo sidebar',
	},
	dismissCardLabel: {
		id: 'home.for-you.rovo-agents-for-you.dismiss-card-label',
		defaultMessage: 'Dismiss {agentTitle}',
		description:
			'Accessible label for the dismiss button on a Rovo agent card; {agentTitle} is the name of the agent',
	},
	projectPlannerTitle: {
		id: 'home.for-you.rovo-agents-for-you.project-planner.title',
		defaultMessage: 'Planner',
		description: 'Title of the Planner Rovo agent card',
	},
	projectPlannerDescription: {
		id: 'home.for-you.rovo-agents-for-you.project-planner.description',
		defaultMessage: 'Plan milestones, sprints, or projects with ease',
		description: 'Description of the Planner Rovo agent card',
	},
	projectPlannerPreviewCaption: {
		id: 'home.for-you.rovo-agents-for-you.project-planner.preview-caption',
		defaultMessage: "Here's your plan:",
		description: 'Caption shown in the preview thumbnail of the Project planner Rovo agent card',
	},
	discoveryFeedbackTitle: {
		id: 'home.for-you.rovo-agents-for-you.discovery-feedback.title',
		defaultMessage: 'Discovery & Feedback',
		description: 'Title of the Discovery & Feedback Rovo agent card',
	},
	discoveryFeedbackDescription: {
		id: 'home.for-you.rovo-agents-for-you.discovery-feedback.description',
		defaultMessage: 'Uncover new ideas and opportunities from your own data',
		description: 'Description of the Discovery & Feedback Rovo agent card',
	},
	discoveryFeedbackPreviewCaption: {
		id: 'home.for-you.rovo-agents-for-you.discovery-feedback.preview-caption',
		defaultMessage: 'Insights for you:',
		description:
			'Caption shown in the preview thumbnail of the Discovery & Feedback Rovo agent card',
	},
});
